export default {"src":"/_next/static/media/fast_casual.30fcb0c5.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};